export enum ChangeRequestCommentType {
  REPORTBY = <any>'REPORTBY',
  CANCELEDLINE = <any>'CANCELEDLINE',
  UNTILTIMEEXTENDED = <any>'UNTILTIMEEXTENDED',
  DIRECTIONCHANGE = <any>'DIRECTIONCHANGE'
}
